module.exports = __webpack_public_path__ + "assets/images/stops-on.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/stops-on.png
// module id = 1526
// module chunks = 1